import { createSelector } from 'reselect'
import { PRODUCT_MODEL_KEY } from 'models/daos/product/constants'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import { searchItemsSectionUtil } from 'modules/section/utils/search-items'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { getStrFromSlugStringUtil } from 'utils/string/get-str-from-slug'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getSearchDomainListSectionSelector } from 'modules/section/selectors/getSearchDomainList/index.js'

const COMMUNITY_POSTS_COUNT = 6

/**
 * Gets the community's posts.
 * @returns {Motivation[]}
 */
function getCommunityPostsProductsSelector () {
  return createSelector(
    state => state && state.motivation,
    getInstanceSectionSelector(),
    (state) => {
      const product = getInstanceSectionSelector()(state)
      return getSearchDomainListSectionSelector({
        section: SECTIONS_NAME.MOTIVATION,
        query: (
          getStrFromSlugStringUtil(
            getValueReduxUtil(product, PRODUCT_MODEL_KEY.SLUG) ||
            ''
          )
        )
      })(state)
    },
    (
      motivation,
      product,
      domainList
    ) =>
      searchItemsSectionUtil({
        domain: motivation,
        section: SECTIONS_NAME.MOTIVATION,
        query: getStrFromSlugStringUtil(
          getValueReduxUtil(product, PRODUCT_MODEL_KEY.SLUG) ||
          ''
        ),
        isExact: true,
        domainList
      }).slice(0, COMMUNITY_POSTS_COUNT)
  )
}

export {
  getCommunityPostsProductsSelector
}
